const MASS_PAYMENTS_HISTORY_GETTERS = {
  items: 'massPaymentsHistory/items',
  loading: 'massPaymentsHistory/loading',
  search: 'massPaymentsHistory/search',
  sort: 'massPaymentsHistory/sort',

  detailSearch: 'massPaymentsHistory/detailSearch',
  detailLoading: 'massPaymentsHistory/detailLoading',
  detailFormData: 'massPaymentsHistory/detailFormData',
  detailItems: 'massPaymentsHistory/detailItems',
  detailPage: 'massPaymentsHistory/detailPage',
  detailTotal: 'massPaymentsHistory/detailTotal',
  detailLimit: 'massPaymentsHistory/detailLimit',
  filters: 'massPaymentsHistory/filters',
}

const MASS_PAYMENTS_HISTORY_DISPATCHERS = {
  goToLoadMassPaymentsHistory:
    'massPaymentsHistory/goToLoadMassPaymentsHistory',
  changePage: 'massPaymentsHistory/changePage',
  onSearch: 'massPaymentsHistory/onSearch',
  onSelectSort: 'massPaymentsHistory/onSelectSort',
  resetSearch: 'massPaymentsHistory/resetSearch',
  resetStore: 'massPaymentsHistory/resetStore',
  goToCopyMassPayment: 'massPaymentsHistory/goToCopyMassPayment',

  goToLoadMassPaymentDetail: 'massPaymentsHistory/goToLoadMassPaymentDetail',
  onSearchDetail: 'massPaymentsHistory/onSearchDetail',
  onSelectDetailFilter: 'massPaymentsHistory/onSelectDetailFilter',
  onLoadMoreDetail: 'massPaymentsHistory/onLoadMoreDetail',
  downloadHistoryReport: 'massPaymentsHistory/downloadHistoryReport',
}

export { MASS_PAYMENTS_HISTORY_GETTERS, MASS_PAYMENTS_HISTORY_DISPATCHERS }
